export enum AssesmentType {
	TEST = 'TEST',
	QUESTIONNAIRE = 'QUESTIONNAIRE',
}
